<div class="style-mood-selection-block">
  <p class="common-bmstv-title-1 common-bmstv-title-1--without-hover style-mood-selection-block__title">
    What genre of beat are you looking for today?
  </p>

  <div class="style-mood-selection-block__select">
    <bmcore-style-select [styleId]="styleId" (filterTracksEvent)="filterTracks($event)"> </bmcore-style-select>
  </div>

  <div class="style-mood-selection-block__select">
    <bmcore-mood-select [moodId]="moodId" (filterTracksEvent)="filterTracks($event)"> </bmcore-mood-select>
  </div>

  <div class="style-mood-selection-block__btn">
    <bmcore-button title="Search" styleName="center" routerPath="{{ url }}"> </bmcore-button>
  </div>
</div>
